Auth = require 'app/scripts/db/auth'
View = require 'app/scripts/views/internal/view'
log = require 'app/scripts/debug/log'
{ track } = require '@trello/analytics'
template = require 'app/scripts/views/templates/footer_chrome'

module.exports = class Footer extends View

  className: 'embedded-board-footer'

  events:
    'click .js-logout': 'logout'

  render: ->
    log('render', "rendering footer")
    @$el.html template({
      url: @options.url
      shouldDisplayLogout: @options.shouldDisplayLogout
    })
    @

  logout: ->
    if Auth.canLogIn()
      Auth.logoutPost(@options.getLogoutReturnUrl())
      track "Log Out"
